import React, { useEffect, useState } from 'react';
import { Grid, Box, LinearProgress, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import TruckTurnaroundCard from '../../../components/KPICards/TruckTurnaroundCard';
import LineChartToggle from './lineChartToggle';
import { unsafeMheCounts, idleManPower, dockUtilization, truckInfo, ppeKitSafetyVest } from '../../../api/FM/overviewPageApis';
import SideBar from './sideBar';
import { CgSpinner } from 'react-icons/cg';
import { FaCheck } from 'react-icons/fa6';
import { RxCross2 } from 'react-icons/rx';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MHEAvailabilityCard from '../../../components/KPICards/MHEAvailabilityCard';
import DeskAvailabilityCard from '../../../components/KPICards/DeskAvailabilityCard';
import RestAreaCard from '../../../components/KPICards/RestAreaCard';
import FutureMetricCard from '../../../components/KPICards/FutureMetricCard';
import DatePickerStore from './Calendar';

const StorePage = () => {
  const theme = useTheme();
  const navigateTo = useNavigate();
  const date = useSelector((state) => state.customization.currentDate);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  console.log('sqafrdewqafcdq aszx', date);

  const [loadingStates, setLoadingStates] = useState({
    authenticated: false,
    status: { loading: true, verified: false },
    dataLoading: true
  });

  const [kpiData, setKpiData] = useState({
    truckData: null,
    mheData: null,
    deskData: null,
    restAreaData: null
  });

  const handleAuthError = () => {
    setLoadingStates((prev) => ({
      ...prev,
      status: { loading: false, verified: false }
    }));

    if (localStorage.getItem('accessToken')) {
      localStorage.removeItem('accessToken');
    }

    const timeoutId = setTimeout(() => {
      navigateTo('/');
    }, 1500);

    return () => clearTimeout(timeoutId);
  };

  const AuthorizationAPI = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      navigateTo('/');
      return;
    }

    try {
      let data = [];
      try {
        console.log('start session api 1st call');
        data = await axios.post(
          `https://neoe2e.neophyte.live/fm-api/users/start_session`,
          {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
      } catch {
        console.log('start session api 2nd call');
      }

      if (data.data?.message === 'Session created successfully') {
        console.log('Session Started');
        setLoadingStates((prev) => ({
          ...prev,
          status: { loading: false, verified: true }
        }));

        setTimeout(() => {
          setLoadingStates((prev) => ({ ...prev, authenticated: true }));
        }, 1500);
      } else {
        console.log('Session could not be started');
        handleAuthError();
      }
    } catch (error) {
      console.error('Error starting session:', error);
      handleAuthError();
    }
  };

  useEffect(() => {
    AuthorizationAPI();
    // eslint-disable-next-line
  }, []);
  console.log('tat', kpiData);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      setLoadingStates((prev) => ({ ...prev, dataLoading: true }));
      try {
        const [truckIdle, unsafeMhe, ppe_kit, idle_man_power, dock_utilization] = await Promise.all([
          truckInfo({ date }),
          unsafeMheCounts({ date }),
          ppeKitSafetyVest({ date }),
          idleManPower({ date }),
          dockUtilization({ date })
        ]);

        console.log('Fetched data', truckIdle, unsafeMhe, ppe_kit, idle_man_power, dock_utilization);

        setKpiData({
          truckData: truckIdle,
          mheData: { date: unsafeMhe },
          deskData: ppe_kit,
          restAreaData: { idleManPower: idle_man_power, dockUtilization: dock_utilization }
        });
      } catch (error) {
        console.error('Error fetching KPI data:', error);
      } finally {
        setLoadingStates((prev) => ({ ...prev, dataLoading: false }));
      }
    };

    if (loadingStates.authenticated) {
      fetchData();
    }

    return () => controller.abort();
  }, [date, loadingStates.authenticated]);

  if (!loadingStates.authenticated) {
    return (
      <div className="w-screen h-screen flex justify-center place-items-center bg-gray-100">
        <div className="px-5 py-4 flex justify-center place-items-center bg-white rounded-md shadow-lg">
          <span>
            {loadingStates.status.loading ? (
              'Authenticating, please wait...'
            ) : (
              <>
                {loadingStates.status.verified
                  ? 'Authenticated successfully, redirecting...'
                  : 'Authentication failed, please try again...'}
              </>
            )}
          </span>
          {loadingStates.status.loading ? (
            <CgSpinner className="ml-4 text-xl text-gray-500 animate-spin" />
          ) : (
            <>
              {loadingStates.status.verified ? (
                <FaCheck className="ml-4 text-xl text-emerald-500" />
              ) : (
                <RxCross2 className="ml-4 text-xl text-rose-500" />
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  if (loadingStates.dataLoading) {
    return (
      <div style={{ display: 'flex', backgroundColor: theme.palette.background.default }}>
        <SideBar />
        <div
          style={{
            flexGrow: 1,
            padding: '20px',
            marginLeft: isMobile ? '0px' : '64px',
            width: isMobile ? '100%' : 'calc(100% - 64px)',
            marginTop: '0',
            transition: 'margin-left 0.3s ease, width 0.3s ease'
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <LinearProgress />
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }

  return (
    <div className="flex">
      <SideBar />
      <div
        className="-m-20 w-full"
        style={{
          marginLeft: isMobile ? '0px' : '30px',
          marginTop: '0',
          transition: 'margin-left 0.3s ease, width 0.3s ease'
        }}
      >
        <Box
          sx={{
            p: isMobile ? -10 : 1,
            mx: isMobile ? 4 : 0,
            width: '100%'
          }}
        >
          <div className={`${isMobile} ? bg-white rounded-xl shadow-md mb-0 -mt-5 : 'bg-white rounded-xl shadow-md mb-4 -mt-14'`}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: isMobile ? 1 : 2,
                flexWrap: isMobile ? 'wrap' : 'nowrap',
                gap: isMobile ? 1 : 0
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'flex-start'
                }}
              >
                <h2
                  className="text-gray-800 font-bold"
                  style={{
                    fontSize: isMobile ? '1.25rem' : isTablet ? '1.5rem' : '1.875rem',
                    lineHeight: isMobile ? '1.75rem' : isTablet ? '2rem' : '2.25rem',
                    whiteSpace: isMobile ? 'normal' : 'nowrap',
                    wordBreak: isMobile ? 'break-words' : 'normal',
                    margin: 0
                  }}
                >
                  Store Dashboard
                </h2>
              </Box>

              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
              >
                <DatePickerStore
                  sx={{
                    '& .MuiInputBase-root': {
                      height: isMobile ? '32px' : isTablet ? '36px' : '40px',
                      fontSize: isMobile ? '0.625rem' : isTablet ? '0.7rem' : '1rem',
                      width: isMobile ? '100px' : isTablet ? '140px' : '160px',
                      minWidth: isMobile ? '100px' : 'auto'
                    },
                    '& .MuiInputBase-input': {
                      padding: isMobile ? '4px 8px' : '8px 12px',
                      fontSize: isMobile ? '0.625rem' : isTablet ? '0.7rem' : '0.875rem'
                    },
                    '& .MuiSvgIcon-root': {
                      fontSize: isMobile ? '0.875rem' : '1rem'
                    }
                  }}
                />
              </Box>
            </Box>
          </div>

          <Grid container spacing={isMobile ? 1 : 1.5}>
            <Grid item xs={12} sm={6} md={2.4}>
              <TruckTurnaroundCard data={kpiData.truckData} loading={loadingStates.dataLoading} />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <DeskAvailabilityCard data={kpiData.deskData} loading={loadingStates.dataLoading} />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <MHEAvailabilityCard data={kpiData.mheData} loading={loadingStates.dataLoading} />
            </Grid>

            <Grid item xs={12} sm={6} md={2.4}>
              <RestAreaCard data={kpiData.restAreaData} loading={loadingStates.dataLoading} />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <FutureMetricCard />
            </Grid>
          </Grid>

          <Box sx={{ width: '100%', mt: 2 }}>
            <LineChartToggle />
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default StorePage;
